// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___rDVe6","m-signature-pad--body":"styles__m-signature-pad--body___2a9C6","m-signature-pad--footer":"styles__m-signature-pad--footer___3LEVX","description":"styles__description___2IRgL","button":"styles__button___6ptCD","clear":"styles__clear___RdN17","save":"styles__save___3OF80","m-signature-pad":"styles__m-signature-pad___1tE78","github":"styles__github___3UAyP","label":"styles__label___35UAk","clearFix":"styles__clearFix___1QKdM","error":"styles__error___gDTJI","errorText":"styles__errorText___3WJQ8"};


//////////////////
// WEBPACK FOOTER
// ./client/app/shared/components/formElements/SurfaceTypesCheckbox/styles.scss
// module id = KWoV
// module chunks = client